import NavBar from "../common/NavBar";
import NavBarFooter from "../common/NavBarFooter";

const FAQ = () => {
    return (
        <div className="outline">
            <NavBar />
            <h1>FAQ</h1>
            <p>What would you like to know</p>
            <NavBarFooter />
        </div>
    )
}

export default FAQ;